const setActiveFilterItem = ($itemList, $activeItem) => {
    for (let i = 0; i < $itemList.length; i++) {
        const $currentItem = $itemList[i];

        if ($currentItem !== $activeItem) {
            $currentItem.classList.remove('filter-bar__item--active');
        } else {
            $currentItem.classList.add('filter-bar__item--active');
        }
    }
};

export { setActiveFilterItem };
